var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 58.125,
    viewBox: "0 0 330.223 58.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116",
    transform: "translate(-91.139 -1799.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 74.736,
    height: 27.961,
    transform: "translate(91.264 1800)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1564",
    "data-name": "Rectangle 1564",
    width: 74.736,
    height: 27.961,
    transform: "translate(176.263 1800)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1565",
    "data-name": "Rectangle 1565",
    width: 74.736,
    height: 27.961,
    transform: "translate(261.263 1800)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 74.736,
    height: 27.961,
    transform: "translate(346.5 1800)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_764",
    "data-name": "$764",
    transform: "translate(125.544 1819)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.723,
    y: 0
  }, "$764")), /*#__PURE__*/React.createElement("text", {
    id: "_7_698",
    "data-name": "$7,698",
    transform: "translate(210.544 1819)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.027,
    y: 0
  }, "$7,698")), /*#__PURE__*/React.createElement("text", {
    id: "_6_484",
    "data-name": "$6,484",
    transform: "translate(295.544 1819)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.027,
    y: 0
  }, "$6,484")), /*#__PURE__*/React.createElement("text", {
    id: "_74",
    "data-name": "$74",
    transform: "translate(384 1819)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.792,
    y: 0
  }, "$74")), /*#__PURE__*/React.createElement("text", {
    id: "Estimated_Revenue",
    "data-name": "Estimated Revenue",
    transform: "translate(213.743 1841)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.471,
    y: 0
  }, "Estimated"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.931,
    y: 14
  }, "Revenue")), /*#__PURE__*/React.createElement("text", {
    id: "Budget",
    transform: "translate(127.743 1841)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.776,
    y: 0
  }, "Budget")), /*#__PURE__*/React.createElement("text", {
    id: "Per_Patient_Acquisition_Cost",
    "data-name": "Per Patient Acquisition Cost",
    transform: "translate(384 1841)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.468,
    y: 0
  }, "Per Patient"), /*#__PURE__*/React.createElement("tspan", {
    x: -36.494,
    y: 14
  }, "Acquisition Cost")), /*#__PURE__*/React.createElement("text", {
    id: "ROI",
    transform: "translate(300.795 1841)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.876,
    y: 0
  }, "ROI")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignSummary);
export default __webpack_public_path__ + "static/media/campaignSummary.721045d3.svg";
export { ForwardRef as ReactComponent };